module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BlackIt.ec86581.eot";